import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import "../ManagerInfo/ManagerPatient/CustomcssMain.css";
import "../loader.css";

function AnimatorList(props) {
  const [AnimatorList, setAnimatorList] = useState([]);
  const navigate = useHistory();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    LoadAnimator();
  }, []);

  const LoadAnimator = () => {
    var authOptions = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/GetAnimatorList`,
    };
    axios(authOptions)
      .then((res) => {
        setAnimatorList(res.data);
        setIsLoading(false);
      });
  };

  const EditAnimator = (valid) => {
    localStorage.setItem("AnimatorId", valid);
  };

  const deleteAnimator = (value) => {
    const datavalue = {
      id: value,
    };
    let token = null;
    try {
      const raw = localStorage.getItem("state");
      if (raw) {
        const state = JSON.parse(raw);
        token = state.auth?.token;
      }
    } catch (e) {
      console.error("Token parsing failed", e);
    }
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/DeleteAnimator`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data", ...(token && { "Authorization": `Bearer ${token}` }) },
    };
    axios(authOptions)
      .then((res) => {
        if (res.data.ExpResult) {
          Swal.fire({
            title: "Failed",
            text: res.data.ExpResult,
            icon: "error",
            confirmButtonText: "Ok",
          });
        } else if (res.data.SuccessResult) {
          Swal.fire({
            title: "Success",
            text: res.data.SuccessResult,
            icon: "success",
            confirmButtonText: "Ok",
          }).then(function () {
            window.location.reload(true);
          });
        } else {
          Swal.fire({
            title: "Error",
            text: "An error occured!",
            icon: "error",
            confirmButtonText: "Ok",
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          title: "Error Occured",
          text: "Something went wrong!",
          icon: "error",
          confirmButtonText: "Ok",
        });
      });
  };

  const BackFunc = () => {
    navigate.push("/index");
  };

  return (
    <>
      <div className="page-content-wrapper">
        {isLoading ? (
          <div className="page-content d-flex justify-content-center align-items-center">
            <div className="my-wrapper">
              <div class="spinner center">
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
              </div>
            </div>

          </div>
        ) : (
          <div className="page-content">
            <div className="page-bar">
              <div className="page-title-breadcrumb">
                <div className=" pull-left">
                  <div className="page-title my-0">List of Animator</div>
                </div>
              </div>
              <div className="page-title-breadcrumb">
                <div className=" pull-right">
                  <button
                    type="submit"
                    className="btn d-inline-block"
                    style={{ backgroundColor: "#1e2b38", color: "#FFF", border: "1px solid #1e2b38" }}
                    onClick={BackFunc}
                  >
                    {" "}
                    <i className="fa fa-arrow-left" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-head">
                        {/* <header>Patient List</header> */}
                        <div className="tools">
                        </div>
                      </div>
                      <div className="card-body ">
                        <div className="table-responsive">
                          <table className="table table-striped custom-table table-hover">
                            <thead>
                              <tr>
                                <th width="10%">Animator ID</th>
                                <th width="20%"> Animator Name</th>
                                <th width="20%"> Prefab Name</th>
                                <th width="40%"> Prefab URL</th>
                                <th style={{ textAlign: "end", paddingRight: "25px" }} width="10%">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {AnimatorList &&
                                AnimatorList.length > 0 &&
                                AnimatorList.map((item) => (
                                  <tr>
                                    <td className="text-left">{item.id}</td>
                                    <td>
                                      <Link
                                        to="/UpdateAnimator"
                                        onClick={() => EditAnimator(item.id)}
                                        className=""
                                      >
                                        <a href="#">{item.animator_Name}</a>
                                      </Link>
                                    </td>

                                    <td className="text-left">{item.animator_Prefab_Name}</td>

                                    <td>
                                      <a href={item.animator_URL} target="_blank">{item.animator_URL}</a>
                                    </td>

                                    <td style={{ textAlign: "end" }}>
                                      <Link
                                        to="/UpdateAnimator"
                                        onClick={() => EditAnimator(item.id)}
                                        className="btn btn-xs py-2"
                                        style={{ backgroundColor: "#1e2b38", color: "#FFF", border: "1px solid #1e2b38" }}
                                      >
                                        <i className="fa fa-pencil"></i>
                                      </Link>
                                      <button
                                        className="btn btn-danger btn-xs py-2"
                                        onClick={() => {
                                          Swal.fire({
                                            title: "Are you sure?",
                                            text: "You won't be able to revert this!",
                                            icon: "warning",
                                            showCancelButton: true,
                                            confirmButtonColor: "#6777ef",
                                            cancelButtonColor: "#d33",
                                            confirmButtonText: "Yes, delete it!",
                                          }).then((result) => {
                                            if (result.isConfirmed) {
                                              deleteAnimator(item.id);
                                            }
                                          });
                                        }}
                                      >
                                        <i className="fa fa-trash-o "></i>
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
        }
      </div>
    </>
  );
}

export default AnimatorList;
